import React from 'react';
import './SendMail.css';
import CloseIcon from '@material-ui/icons/Close';
import { Button } from '@material-ui/core';
import { useForm } from "react-hook-form";
import { closeSendMessage } from '../../features/mailSlice';
import { useDispatch } from 'react-redux';
import firebase from "firebase";
import { db } from '../../DataLayerConfig/Firebase';

function SendMail() {

    let { register, handleSubmit, watch, errors } = useForm();
    let dispatch = useDispatch();
    let onSubmit = (formData) => {
        db.collection('Emails').add({
            to: formData.to,
            subject: formData.subject,
            message: formData.message,
            timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });

        dispatch(closeSendMessage);
    };

    return (
        <div className="sendMail">
            <div className="sendMail__header">
                <h3>New Message</h3>
                <CloseIcon onClick={() => dispatch(closeSendMessage)} className="sendMail__close" />
            </div>

            <form onSubmit={handleSubmit(onSubmit)}>
                <input name="to" placeholder="To" type="email" ref={register({ required: true})} />
                {errors.to && <p className="sendMail__error">To is required</p>}
                
                <input name="subject" placeholder="Subject" type="text" ref={register({ required: true})} />
                {errors.subject && <p className="sendMail__error">Subject is required</p>}
                
                <input name="message" placeholder="Message..." type="text" className="sendMail__message" ref={register({ required: true})} />
                {errors.message && <p className="sendMail__error">Message is required</p>}

                <div className="sendMail__options">
                    <Button 
                        className="sendMail__send"
                        variant="contained"
                        color="primary"
                        type="submit"
                    >
                        Send
                    </Button>
                </div>
            </form>
        </div>
    )
}

export default SendMail;
